import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ProductManualRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { ProductRecommendationsState, StateWithProductRecommendations } from '../product-recommendations-state';
import { getFeatureState } from './feature.selectors';

export const getProductManualRecommendationState: MemoizedSelector<
  StateWithProductRecommendations,
  StateUtils.LoaderState<ProductManualRecommendationEntity>
> = createSelector(getFeatureState, (state: ProductRecommendationsState) => state.productManualRecommendation);

export const getProductManualRecommendationValue: MemoizedSelector<
  StateWithProductRecommendations,
  ProductManualRecommendationEntity
> = createSelector(
  getProductManualRecommendationState,
  (state: StateUtils.LoaderState<ProductManualRecommendationEntity>) => StateUtils.loaderValueSelector(state) ?? {},
);

export const getProductManualRecommendationLoading: MemoizedSelector<StateWithProductRecommendations, boolean> =
  createSelector(
    getProductManualRecommendationState,
    (state: StateUtils.LoaderState<ProductManualRecommendationEntity>) => StateUtils.loaderLoadingSelector(state),
  );

export const getProductManualRecommendationError: MemoizedSelector<StateWithProductRecommendations, boolean> =
  createSelector(
    getProductManualRecommendationState,
    (state: StateUtils.LoaderState<ProductManualRecommendationEntity>) => StateUtils.loaderErrorSelector(state),
  );

export const getProductManualRecommendationSuccess: MemoizedSelector<StateWithProductRecommendations, boolean> =
  createSelector(
    getProductManualRecommendationState,
    (state: StateUtils.LoaderState<ProductManualRecommendationEntity>) => StateUtils.loaderSuccessSelector(state),
  );
